// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1206":"6b5f0ed8130809e3","2750":"acd1979a697ca15d","8139":"bf5e4e8aca57b4f1","8862":"6e6aa740c156372e"}[chunkId] + ".css";
};